export const GET_QUOTES = "GET_QUOTES";
export const GET_QUOTE_BY_ID = "GET_QUOTE_BY_ID";
export const UPDATE_QUOTE = "UPDATE_QUOTE";
export const DELETE_QUOTE = "DELETE_QUOTE";
export const CREATE_QUOTE = "CREATE_QUOTE";
export const REQUEST_PL_CODE = "REQUEST_PL_CODE";
export const GET_QUOTE_BY_REF = "GET_QUOTE_BY_REF";
